import ApiCaller from '../api';

export const getEligibiity = async () => {
    try {
        const res = await ApiCaller.Get('/all-eligibilities');
        console.log(res);
        const resData = res?.data?.data;
        let elegibilityOptions = [];

        const elegibility = resData?.map((item) => {
            elegibilityOptions?.push({
                label: item.name,
                value: item.id,
            });
        });
        return elegibilityOptions;
    } catch (e) {
        return [];
    }
};

export const getSchedules = async () => {
    try {
        const res = await ApiCaller.Get('/all-schedules');
        const resData = res?.data?.data;
        let scheduleOption = [];

        const schedule = resData?.map((item) => {
            scheduleOption?.push({
                label: item.name,
                value: item.id,
            });
        });
        return scheduleOption;
    } catch (e) {
        console.log(e);
        return [];
    }
};
export const getUserData = async () => {
    try {
        // Get user ID from localStorage
        const user = localStorage.getItem('user');
        const userId = user ? JSON.parse(user).id : null;
        console.log('userId', userId);

        // Check if userId is available
        if (!userId) {
            throw new Error('User ID is not found in local storage');
        }

        // Call the API with the user ID
        const res = await ApiCaller.Get(`/user`);

        // Assuming the response is in res.data.data
        const userData = res?.data?.data;

        return userData; // Return the user data fetched from API
    } catch (e) {
        console.log(e); // Log any error that happens during the fetch
        return null; // Return null if an error occurs
    }
};

export const getUserRoles = async () => {
    try {
        const res = await ApiCaller.Get('/roles');
        const resData = res?.data?.data;
        let rolesOption = [];
        const role = resData?.map((item) => {
            rolesOption?.push({
                label: item.name,
                value: item.id,
            });
        });
        return rolesOption;
    } catch (e) {
        console.log(e);
        return [];
    }
};

export const getCompanies = async () => {
    try {
        const res = await ApiCaller.Get('/companies');
        const resData = res?.data?.data;
        let companiesOption = [];
        const role = resData?.map((item) => {
            companiesOption?.push({
                label: item.name,
                value: item.id,
            });
        });
        return companiesOption;
    } catch (e) {
        console.log(e);
        return [];
    }
};

export const getAddresses = async () => {
    try {
        const id = localStorage.getItem('PropertyKey');
        const res = await ApiCaller.Get(`/property/${id}/addresses`);
        console.log(res);
        const resData = res?.data?.data?.addresses;
        console.log(resData?.addresses);
        let addressesOption = [];
        const role = resData?.map((item) => {
            addressesOption?.push({
                label: `${item.streetNumber} - ${item.streetName} - ${item.city} ${item.zip}`,
                value: item.id,
            });
        });
        return addressesOption;
    } catch (e) {
        console.log(e);
        return [];
    }
};

// only for location forms as i have to show 'All' key there and i cannot do it in the component
// as whenever the component render it will add 'All' key, so we might have duplicate 'All' key so
// created a seperate function for location form.
export const getAddressesLoc = async () => {
    try {
        const id = localStorage.getItem('PropertyKey');
        const res = await ApiCaller.Get(`/property/${id}/addresses`);
        console.log(res);
        const resData = res?.data?.data?.addresses;
        console.log('heyy I am addrrrss', res);
        let addressesOption = [];
        const role = resData?.map((item) => {
            addressesOption?.push({
                label: `${item.streetNumber} - ${item.streetName} - ${item.city} ${item.zip}`,
                value: item.id,
            });
        });
        console.log(addressesOption);
        addressesOption.length > 0 &&
            addressesOption.push({
                label: 'All',
                value: 'All',
            });
        return addressesOption;
    } catch (e) {
        console.log(e);
        return [];
    }
};

export const getIncidents = async () => {
    try {
        const id = localStorage.getItem('PropertyKey');
        const res = await ApiCaller.Get(`/property/${id}/incident-type`);
        const resData = res?.data?.data;
        let incidentOptions = [];
        const role = resData?.map((item) => {
            incidentOptions?.push({
                label: item.name,
                value: item.id,
            });
        });
        return incidentOptions;
    } catch (e) {
        console.log(e);
        return [];
    }
};

export const getAllIncidents = async () => {
    try {
        let res = await ApiCaller.Get(`/all-incident-type`);
        if (res.status == 200) {
            const resData = res?.data?.data;
            let incidentOptions = [];
            const role = resData?.map((item) => {
                incidentOptions?.push({
                    label: item.name,
                    value: item.id,
                });
            });
            return incidentOptions;
        }
    } catch (err) {
        console.log(err);
        return [];
    }
};

export const getAllUsers = async (roles, status, type = 'username') => {
    try {
        let res = await ApiCaller.Get(
            `/users/all?${roles?.admin ? 'roles[]=admin&' : ''}${roles?.guard ? 'roles[]=guard&' : ''}${roles?.supervisor ? 'roles[]=supervisor&' : ''}${roles?.manager ? 'roles[]=manager' : ''}${status ? `status=${status}` : ''}`,
        );
        console.log(res, 'getAllUsers');

        if (res.status == 200) {
            const resData = res?.data?.data;
            let userOptions = [];
            const role = resData?.map((item) => {
                userOptions?.push({
                    label:
                        type == 'username'
                            ? `${item?.firstName} ${item?.lastName}`
                            : `${item?.firstName} ${item?.lastName}`,
                    value: item.id,
                    email: item.email,
                });
            });
            console.log(userOptions, 'res');
            return userOptions;
        }
    } catch (err) {
        console.log(err);
        return [];
    }
};

export const getActiveUsers = async (params) => {
    console.log(params);
    try {
        // have to handle this pagination scenerio because its set to 50.
        let res = await ApiCaller.Get(
            `/users?status=active&perPage=${params?.perPage ?? 55}&page=${params?.page ?? ''}&search=${params?.search ?? ''}`,
        );
        if (res.status == 200) {
            const resData = res?.data?.data;
            const resPaginate = res?.data?.paginate;
            console.log('hello response', resData);
            let userOptions = [];
            const role = resData?.map((item) => {
                userOptions?.push({
                    label: `${item.firstName} ${item.lastName}`,
                    value: item.id,
                });
            });
            const payload = { userOptions, resPaginate };
            console.log('payloadofconnectivity', payload);
            return payload;
        }
    } catch (err) {
        console.log(err);
        return [];
    }
};

export const getShiftsForUser = async (userId) => {
    try {
        if (!userId) {
            console.error('User ID is required.');
            return [];
        }

        const res = await ApiCaller.Get(`/shifts?user_id=${userId}`);
        if (res.status === 200) {
            const resData = res?.data?.data;
            console.log('hy', resData);
            let shiftOptions = [];
            resData?.forEach((shift) => {
                shiftOptions.push({
                    label: `${shift.shiftDate} from ${shift.startTime} to ${shift.endTime}`,
                    value: shift.id,
                });
            });
            console.log('shiftOptions', shiftOptions);
            return shiftOptions;
        } else {
            console.warn(`Unexpected response status: ${res.status}`);
            return [];
        }
    } catch (err) {
        console.error(`Error fetching shifts for user ID: ${userId}`, err);
        return [];
    }
};

export const getAllProperties = async () => {
    try {
        let res = await ApiCaller.Get(`/properties?search=&perPage=&sortBy=`);
        if (res.status == 200) {
            const resData = res?.data?.data || [];
            // Return full property objects so consumers can derive addresses/locations
            return resData;
        }
        return [];
    } catch (err) {
        console.log(err);
        return [];
    }
};

/**
 * One page of properties, for the searchable infinite-scroll dropdowns.
 * Returns the raw property objects (so consumers can derive addresses/locations)
 * plus whether another page exists.
 */
export const getPropertiesPage = async ({
    page = 1,
    search = '',
    perPage = 25,
    sortBy = '',
} = {}) => {
    try {
        const res = await ApiCaller.Get(
            `/properties?search=${encodeURIComponent(
                search || '',
            )}&perPage=${perPage}&page=${page}&sortBy=${sortBy}`,
        );
        const data = res?.data?.data || [];
        const paginate = res?.data?.paginate;
        return {
            data,
            hasMore: paginate
                ? paginate.currentPage < paginate.lastPage
                : data.length === perPage,
        };
    } catch (err) {
        console.log(err);
        return { data: [], hasMore: false };
    }
};

/**
 * Full property detail (includes `addresses` and `locations`), used to populate
 * the dependent Address/Location dropdowns for a property that may not be on a
 * page the dropdown has loaded.
 */
export const getPropertyDetail = async (id) => {
    if (!id) return null;
    try {
        const res = await ApiCaller.Get(`/property/${id}`);
        return res?.data?.data || null;
    } catch (err) {
        console.log(err);
        return null;
    }
};

export const getAllLocations = async () => {
    try {
        let res = await ApiCaller.Get(`/locations/all`);
        if (res.status == 200) {
            const resData = res?.data?.data;
            let locationsOptions = [];
            const locations = resData?.map((item) => {
                locationsOptions?.push({
                    label: item.name,
                    value: item.id,
                });
            });
            return locationsOptions;
        }
    } catch (err) {
        console.log(err);
        return [];
    }
};

export const getLocationsByProperty = async (propertyId) => {
    try {
        if (!propertyId) return [];
        let res = await ApiCaller.Get(`/property/${propertyId}`);
        if (res.status == 200) {
            const locations = res?.data?.data?.locations;
            let locationsOptions = [];
            locations?.map((item) => {
                locationsOptions?.push({
                    label: item.name,
                    value: item.id,
                });
            });
            return locationsOptions;
        }
        return [];
    } catch (err) {
        console.log(err);
        return [];
    }
};

export const getAllNotifications = async (payload) => {
    let { perPage, page } = payload;
    try {
        let res = await ApiCaller.Get(
            `/notifications?perPage=${perPage ?? 10}&page=${page ?? 1}&sortOrder=desc&sortBy=createdAt`,
        );
        if (res.status == 200) {
            return res?.data;
        }
    } catch (err) {
        console.log(err);
        return [];
    }
};

export const verifyCompany = async (companyUrl) => {
    try {
        const response = await ApiCaller.Get(
            `/company/url/validation?companyUrl=${companyUrl}&isExist=1`,
        );
        if (response?.status === 200) {
            const data = response.data.data;
            return data;
        }
    } catch (error) {
        return error;
    }
};

export const getTimeOffTypes = async (params) => {
    try {
        let res = await ApiCaller.Get(
            `/time-off-type?per_page=${params?.per_page ?? 10}&page=${params?.page ?? 1}&search=${params?.search ?? ''}`,
        );
        if (res.status == 200) {
            return res.data;
        }
    } catch (err) {
        console.log(err);
        return [];
    }
};

export const getAllTimeOffTypes = async () => {
    try {
        let res = await ApiCaller.Get(`/time-off-type?per_page=100&page=1`);

        let typeOptions = [];
        const mandatoryTypes = ['personal', 'sick', 'vacation'];

        if (res.status == 200) {
            const resData = res?.data?.data || [];

            // Add API types
            resData.forEach((item) => {
                const isMandatory = ['personal', 'sick', 'vacation'].includes(
                    item.name.toLowerCase(),
                );
                // Show if mandatory or explicit active flag (support both snake_case and camelCase just in case)
                const isActive = item.is_active || item.isActive;

                if (isMandatory || isActive) {
                    typeOptions.push({
                        label: item.name,
                        value: item.name,
                    });
                }
            });
        }

        // Ensure mandatory types are present
        mandatoryTypes.forEach((type) => {
            const exists = typeOptions.some(
                (opt) => opt.value.toLowerCase() === type,
            );
            if (!exists) {
                // Capitalize first letter for label
                const label = type.charAt(0).toUpperCase() + type.slice(1);
                typeOptions.push({
                    label: label,
                    value: type,
                });
            }
        });

        return typeOptions.sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically
    } catch (err) {
        console.log(err);
        // Fallback to mandatory types on error
        return [
            { label: 'Personal', value: 'personal' },
            { label: 'Sick', value: 'sick' },
            { label: 'Vacation', value: 'vacation' },
        ];
    }
};
